<h2 mat-dialog-title>
    {{ data.title }}
</h2>
<mat-dialog-content>
    <admin-translatable-label-field
        label="Label"
        [(value)]="data.label"
        [locales]="data.supportedLocales"
        [(translations)]="data.labelTranslations"
    />
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="closeAndSetLabels()">Ok</button>
</mat-dialog-actions>
